import { Loader2 } from "lucide-react";
import { ComingSoonHero, QaNotice } from "@/components/create/StudioNotices";
import { ProStudio } from "@/components/create/ProStudio";
import { VideoForm } from "@/components/create/VideoForm";
import { PresetGrid } from "@/components/create/explore/PresetGrid";
import { StudioHeader } from "@/components/create/explore/StudioHeader";
import { hfOpen, useOpenPreset, useMediaConfig, usePresets, videoOpen } from "@/lib/studio";

export default function VideoStudioPage() {
  const config = useMediaConfig().data;
  const onOpen = useOpenPreset();
  const presets = (usePresets().data?.items || []).filter((p) => p.kind === "video" && p.status === "published");
  return (
    <div className="h-full overflow-y-auto" data-testid="video-studio-page">
      <StudioHeader title="Video" back />
      <div className="mx-auto w-full max-w-6xl space-y-8 px-4 pb-20 pt-5 sm:px-6 sm:pt-8">
        {!config && <div className="flex h-40 items-center justify-center text-zinc-500"><Loader2 className="h-5 w-5 animate-spin" /></div>}
        {config && videoOpen(config) && <VideoForm offer={config.video} />}
        {config && hfOpen(config) && config.higgsfield.access === "qa" && <QaNotice budget={config.image.qa_budget} tools="video tools" />}
        {config && hfOpen(config) && <ProStudio testId="video-pro-studio" filter={(m) => m.kind === "video" && m.studio === "video"} initialModelId="pixverse/v6/text-to-video" />}
        {config && !videoOpen(config) && !hfOpen(config) && (
          <ComingSoonHero covers={presets.map((p) => p.cover_url)} testId="video-coming-soon" title="Video is coming soon"
            body="Turn a description into a short cinematic clip. Video opens once its pricing is final — until then you can preview the video presets below." />
        )}
        {presets.length > 0 && (
          <section className="space-y-4" data-testid="video-presets">
            <h2 className="text-xl font-bold tracking-tight text-white sm:text-2xl">Video presets</h2>
            <PresetGrid presets={presets} onOpen={onOpen} />
          </section>
        )}
      </div>
    </div>
  );
}
